import * as TK from 'pages/SiteCreationPage/translations/constants';
import { Translations } from 'translations/types';

export const siteCreationPageEnUsLocale: Translations = {
  [TK.SITE_CREATION_PAGE_TITLE]: 'Let’s Set up Your Site',
  [TK.SITE_CREATION_PAGE_EMAIL_CHIP]: 'Your Email: {{email}}',
};
